var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header-content"),_vm._t("main-content",[_c('tip-tap',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})]),_vm._t("footer-content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }